import { forwardRef, type HTMLAttributes } from 'react';
import GoodsIcon from '@assets/img/dice-game/goods-card.svg?react';
import MaterialIcon from '@assets/img/dice-game/material-card.svg?react';
import ResourceIcon from '@assets/img/dice-game/resource-card.svg?react';
import DolarIcon from '@assets/img/icons/dolar.svg?react';
import cn from 'classnames';

import { type MiniGameType } from '@/common/types/dice-game';

import css from './styles.module.scss';

interface CardFrontProps extends HTMLAttributes<HTMLDivElement> {
  kind: Omit<MiniGameType, 'tgem' | 'str'>;
}

const CardFront = forwardRef<HTMLDivElement, CardFrontProps>(
  ({ kind, ...props }, ref) => {
    const iconClassName = 'w-[28.32%] h-[28.32%] sm-h:w-[32%] sm-h:h-[32%]';

    return (
      <div ref={ref} {...props} className={cn(css.cardFront, props.className)}>
        {kind === 'cash' && <DolarIcon className={iconClassName} />}
        {kind === 'Resource' && <ResourceIcon className={iconClassName} />}
        {kind === 'Material' && <MaterialIcon className={iconClassName} />}
        {kind === 'Product' && <GoodsIcon className={iconClassName} />}
      </div>
    );
  },
);

export { CardFront };
